import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { combineReducers } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import usersReducer from "./slices/userSlice";
import themeReducer from "./slices/themeSlice";
import i18nReducer from "./slices/i18nSlice";
import sidebarReducer from "./slices/sidebarSlice";
import uiReducer from "./slices/uiSlice";

// Persist configuration for theme and i18n
const themePersistConfig = {
  key: "theme",
  storage,
  whitelist: ["theme"],
};

const i18nPersistConfig = {
  key: "i18n",
  storage,
  whitelist: ["language", "fallbackLanguage"],
};

const sidebarPersistConfig = {
  key: "sidebar",
  storage,
  whitelist: ["collapsed"],
};

const rootReducer = combineReducers({
  auth: authReducer,
  users: usersReducer,
  theme: persistReducer(themePersistConfig, themeReducer),
  i18n: persistReducer(i18nPersistConfig, i18nReducer),
  sidebar: persistReducer(sidebarPersistConfig, sidebarReducer),
  ui: uiReducer,
});

export const store:any = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
        ignoredPaths: ["persist"],
      },
    }),
  devTools: process.env.NODE_ENV !== "production",
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
